import { CheckCircle2, Car, Wrench, ClipboardList, Ban } from "lucide-react";

const TILES = [
  { key: "available", label: "Available", icon: CheckCircle2, tone: "border-emerald-200 bg-emerald-50/70 text-emerald-900" },
  { key: "in_use", label: "In Use", icon: Car, tone: "border-sky-200 bg-sky-50/70 text-sky-900" },
  { key: "maintenance", label: "Maintenance", icon: Wrench, tone: "border-amber-200 bg-amber-50/70 text-amber-900" },
  { key: "needs_inspection", label: "Need Inspection", icon: ClipboardList, tone: "border-amber-200 bg-amber-50/70 text-amber-900" },
  { key: "unavailable", label: "Unavailable", icon: Ban, tone: "border-slate-200 bg-slate-50 text-slate-700" },
];

/** Fast availability summary above the calendar: computed by the same
 * availability engine the grid and suggest-vehicles use (fleet_calendar
 * .service.compute_availability_summary), so this headline can never
 * disagree with the grid below it. */
export function AvailabilitySummaryStrip({ summary, loading }) {
  if (loading || !summary) {
    return (
      <div className="rounded-xl border border-slate-200 bg-white p-4 text-sm text-slate-500" data-testid="fc-summary-loading">
        Loading availability…
      </div>
    );
  }
  const byCategory = (summary.by_category || []).filter((c) => c.total > 0);
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 space-y-3" data-testid="fc-summary-strip">
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-2">
        {TILES.map((t) => {
          const Icon = t.icon;
          const value = summary[t.key] ?? 0;
          return (
            <div key={t.key} className={`rounded-lg border p-2.5 ${t.tone}`} data-testid={`fc-summary-tile-${t.key}`}>
              <div className="flex items-center gap-1.5">
                <Icon className="w-3.5 h-3.5" />
                <span className="text-[10px] uppercase tracking-[0.15em] font-semibold opacity-80">{t.label}</span>
              </div>
              <div className="mt-1 font-display text-xl font-bold">{value}</div>
            </div>
          );
        })}
      </div>
      {byCategory.length > 0 && (
        <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-slate-600 pt-1 border-t border-slate-100">
          {byCategory.map((c) => (
            <span key={c.category} data-testid={`fc-summary-category-${c.category}`}>
              <strong className="text-slate-900">{c.available}</strong>/{c.total} {c.category}
            </span>
          ))}
          <span className="ml-auto text-slate-400">{summary.total_vehicles} vehicles total</span>
        </div>
      )}
    </div>
  );
}
